import * as React from 'react'
import { CITATIONS_DASHBOARD } from '@chegg-wt/core/constants/citationFlow'
import { getProjectsExperience } from '@chegg-wt/core/utils/citationFlow'
import { useQuery } from '@apollo/client'
import { GetProjects } from '@chegg-wt/core/queries/GetProjects'
import { GET_PROJECTS } from '@chegg-wt/core/queries/Project'
import BaseProjectList from '@chegg-wt/core/components/BaseProjectList'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { Dispatch } from 'redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { SEE_ALL_PROJECTS } from '@chegg-wt/core/components/Dashboard/utils/testIds'

import { CitationsExperience } from '@chegg-wt/core/types/citation-flow'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { ListContainer, SeeAllLink } from '../BaseProjectList/styled'
import { useRoutesContext } from '../RoutesContext'
import AppLink from '../AppLink'

interface ProjectListProps {
  citationsExperience: CitationsExperience
  onUserClickSeeAll: () => void
  onUserClickCitation: () => void
}

export const MAX_PROJECT_ITEMS = 4

const ProjectList: React.FC<ProjectListProps> = ({
  citationsExperience,
  onUserClickSeeAll,
  onUserClickCitation,
}) => {
  const { toFolders, toCitationsDashboard } = useRoutesContext()

  const response = useQuery<GetProjects>(GET_PROJECTS, {
    ssr: false,
    fetchPolicy: 'cache-and-network',
    variables: {
      limit: 4,
    },
  })

  if (response.loading) {
    return (
      <ListContainer loadingContainer>
        <LoadingDots message="Loading your projects" />
      </ListContainer>
    )
  }

  if (
    response.error ||
    !response.data ||
    !response.data.projects ||
    !response.data.projects.length
  ) {
    return null
  }

  const { projects } = response.data

  const seeAllRoute =
    getProjectsExperience() === CITATIONS_DASHBOARD ? toCitationsDashboard() : toFolders()

  const handleSeeAllClick = () => {
    onUserClickSeeAll()
  }

  const handleCitationClick = () => {
    onUserClickCitation()
  }
  const footerContent = (
    <AppLink route={seeAllRoute}>
      <SeeAllLink
        aria-label="See all projects"
        data-test={SEE_ALL_PROJECTS}
        onClick={handleSeeAllClick}
      />
    </AppLink>
  )

  const hasMaxOrMoreItems = projects.length >= MAX_PROJECT_ITEMS

  return (
    <BaseProjectList
      projects={projects}
      onCitationListClick={handleCitationClick}
      hideActionMenu
      footerContent={hasMaxOrMoreItems && footerContent}
      citationsExperience={citationsExperience}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  currentStyle: currentStyleSelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClickSeeAll: () =>
    dispatch(userClick({ origin: origins.dashboardClickProjectSeeAll })),
  onUserClickCitation: () =>
    dispatch(userClick({ origin: origins.dashboardClickProjectCitation })),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList)
